export * from './home';
export * from './about';
export * from './contact';
export * from './support';
export * from './terms';
export * from './features';



// WEBPACK FOOTER //
// ./src/comp/pages/index.js